import { render, staticRenderFns } from "./FormLinkButton.vue?vue&type=template&id=5a42ffd8&"
import script from "./FormLinkButton.vue?vue&type=script&lang=ts&"
export * from "./FormLinkButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports